module.exports = __webpack_public_path__ + "img/فارسی+انگلیسی.ed2bf085.png";